import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthFacade } from '../../services/auth-facade';

const resolveReturnTo = (rawReturnTo: string | null): string => {
  if (!rawReturnTo) return '/';
  return rawReturnTo.startsWith('/') ? rawReturnTo : '/';
};

export const signupGuard: CanActivateFn = async (route, _state) => {
  const returnTo = resolveReturnTo(route.queryParamMap.get('returnTo'));
  await inject(AuthFacade).signup({ returnTo });
  return false;
};
